// src/hooks/useCacheVersion.js
import { useEffect, useMemo } from 'react';
import { useAppConfig } from '@state'; // 这里可以正常使用useAppConfig

// 定义缓存版本号的key
const CACHE_VERSION_KEY = 'ohif_cache_version';
// 默认版本号（兜底）
const DEFAULT_CACHE_VERSION = '1.0.0';

/**
 * 自定义Hook：处理缓存版本号的校验与更新
 */
export const useCacheVersion = () => {
  // 这里可以安全使用useAppConfig，因为是在自定义Hook中
  const [appConfig = {}] = useAppConfig() || [];
  // 直接读取window.config的version，使用useMemo缓存（避免每次渲染都读取）
  const currentVersion = useMemo(() => {
    // 优先使用window.config.version，兜底用默认值
    console.log('window.config.version:', window.config?.version); // 验证是否为1.0.1
    return window.config?.version || DEFAULT_CACHE_VERSION;
  }, []); // 空依赖：仅在组件挂载时读取一次（若需动态监听，可后续扩展）

  useEffect(() => {
    // 缓存版本号校验逻辑

    const storedVersion = localStorage.getItem(CACHE_VERSION_KEY);

    if (currentVersion !== storedVersion) {
      localStorage.setItem(CACHE_VERSION_KEY, currentVersion);
      // 清理token逻辑
      if ((window as any).tokenManager?.clearToken) {
        (window as any).tokenManager.clearToken();
      }
    }
  }, [appConfig]); // 依赖appConfig变化

  // 可选：返回版本号，供调用者使用
  return {
    currentVersion: appConfig.version || DEFAULT_CACHE_VERSION,
    storedVersion: localStorage.getItem(CACHE_VERSION_KEY),
  };
};
